var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { v4 as uuidv4 } from "uuid";
import { ExitStep, } from "./EngineData";
import EngineDataAPI from "./EngineDataAPI";
import { getFingerprint } from "./FingerprintGenerator";
export const initialHeartbeat = {
    clicks: 0,
    exitStep: ExitStep.LIST,
    pages: 1,
    dirty: false,
};
// we need the heartbeat because its properties may update before engineData is updated
let heartbeat = initialHeartbeat;
// recover engineData from sessionStorage, it must have an id / fingerprint / ip
// FIXME: breaks with SSR
const sessionEngineData = getFromSessionStorage();
let engineData;
// initialize engine and heartbeat with session values
if (sessionEngineData) {
    engineData = sessionEngineData;
    heartbeat = {
        clicks: sessionEngineData.clicks,
        exitStep: sessionEngineData.exitStep,
        pages: sessionEngineData.pages,
        dirty: false,
    };
}
const exitStepOrder = Object.values(ExitStep);
const queries = [];
const engineDataAPI = new EngineDataAPI({
    // @ts-ignore
    url: window.__additionalData.ENGINE_DATA_API_URL,
});
function getFromSessionStorage() {
    const rawEngineData = sessionStorage.getItem("WBK-ENGINE-DATA");
    return rawEngineData ? JSON.parse(atob(rawEngineData)) : undefined;
}
function storeInSessionStorage(data) {
    sessionStorage.setItem("WBK-ENGINE-DATA", btoa(JSON.stringify(data)));
}
async function sendEngineData(data) {
    pushEngineDataToDataLayer(data);
    // send engineData to API
    await engineDataAPI.create(data);
}
export async function sendQuery(query) {
    const lQuery = Object.assign({}, query);
    if (!lQuery.children) {
        delete lQuery.children;
    }
    if (!lQuery.seniors) {
        delete lQuery.seniors;
    }
    if (!lQuery.teenagers) {
        delete lQuery.teenagers;
    }
    if (!lQuery.babies) {
        delete lQuery.babies;
    }
    queries.push(lQuery);
    // @ts-ignore
    pushEngineDataToDataLayer(Object.assign(Object.assign({}, engineData), { queries }));
    // send lQueryInfo to API
    await engineDataAPI.addQuery(engineData.id, lQuery);
}
// this must be called every 5 seconds
export async function sendHeartbeat() {
    // only send if something has changed (dirty heartbeat)
    if (!engineData || !heartbeat.dirty) {
        return;
    }
    // send heartbeat to API (patch engineData)
    pushEngineDataToDataLayer(engineData);
    await engineDataAPI.patch(engineData.id, heartbeat);
    heartbeat.dirty = false;
}
setInterval(sendHeartbeat, 5000);
export async function sendBookInfo(bookInfo) {
    pushEngineDataToDataLayer(engineData);
    // send bookInfo to API (patch engineData)
    await engineDataAPI.patch(engineData.id, bookInfo);
}
function updateHeartbeat(lastHeartbeat) {
    heartbeat = Object.assign(Object.assign(Object.assign({}, heartbeat), lastHeartbeat), { dirty: true });
    if (engineData) {
        engineData = Object.assign(Object.assign({}, engineData), heartbeat);
        storeInSessionStorage(engineData);
    }
}
export function addClick() {
    updateHeartbeat({ clicks: heartbeat.clicks + 1 });
}
export function addPages() {
    updateHeartbeat({ pages: heartbeat.pages + 1 });
}
export function updateExitStep(exitStep) {
    const newExitStepOrder = exitStepOrder.indexOf(exitStep);
    const currentExitStepOrder = exitStepOrder.indexOf(heartbeat.exitStep);
    if (newExitStepOrder > currentExitStepOrder) {
        updateHeartbeat({ exitStep });
    }
}
// this function must be called when engine initializes and propertyARI / propertyData / configuration are fetched
export async function init(data, firstQuery, ipInfo) {
    // FIXME: breaks with SSR
    document.body.addEventListener("click", addClick, true);
    // AVOID tracking direct access to booking confirmation
    if (!sessionEngineData) {
        const fingerprint = await getFingerprint();
        // if engineData does not exist in sessionStorage take it from param and store it
        engineData = sessionEngineData || Object.assign(Object.assign(Object.assign(Object.assign({}, data), initialHeartbeat), ipInfo), { fingerprint, id: uuidv4(), booked: false });
        // if sessionEngineData does not exists, it means it has not been tracked, we track it
        await sendEngineData(engineData);
        storeInSessionStorage(engineData);
    }
    else {
        engineData = sessionEngineData;
    }
    // add and track first session query
    // we do not want to keep queries across sessions
    await sendQuery(firstQuery);
}
function pushEngineDataToDataLayer(data) {
    // tslint:disable-next-line:no-shadowed-variable
    const { fingerprint, ip } = data, engineData = __rest(data, ["fingerprint", "ip"]);
    // @ts-ignore
    if (window && window.dataLayer) {
        // @ts-ignore
        window.dataLayer.push({ engineData });
    }
    else {
        // @ts-ignore
        window.dataLayer = [{ engineData }];
    }
}
// For use with markups
// @ts-ignore
window.engineDataCollector = {
    init,
    updateExitStep,
    addPages,
    addClick,
    sendHeartbeat,
    sendQuery,
};
